import { render, staticRenderFns } from "./DialogDiasEstoque.vue?vue&type=template&id=1a0835ce"
import script from "./DialogDiasEstoque.vue?vue&type=script&lang=js"
export * from "./DialogDiasEstoque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports